// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__351VX","label":"Labeled_label__h7Xly","divider":"Labeled_divider__24ZfH"};